import SignUpContext from '@activities/auth/SignUpActivity/context/SignUpContext';
import { ReactNode, useEffect, useState } from 'react';

interface Props {
    children?: ReactNode;
    kakaoId?: number;
    nickname?: string;
    appleId?: string;
    googleId?: string;
    verificationToken?: string;
}

function SignUpContextProvider({
    children, kakaoId, nickname, appleId, googleId, verificationToken,
}:Props) {
    const useVerified = useState<boolean>(false);
    const useValue = useState<string>('');
    const useMarketing = useState<boolean>(false);
    const useLocation = useState<boolean>(false);
    const useInputValue = useState<string>('');
    const useInputAuthCode = useState<string>('');
    const useSelectedTermCategories = useState<string[]>([]);
    return (
        <SignUpContext value={{
            useVerified,
            useValue,
            useMarketing,
            useLocation,
            useInputValue,
            useInputAuthCode,
            useSelectedTermCategories,
            kakaoId,
            nickname,
            appleId,
            googleId,
            verificationToken,
        }}>
            {children}
        </SignUpContext>
    );
}

export default SignUpContextProvider;
